<template>
  <div>
    <!-- <swiper :options="swiperOption" class="cal-swip related-product-swiper">
      <swiper-slide
        v-for="item in related_items"
        :key="item.objectId"
        class="cursor-pointer"
      >
        <div class="bg-white text-center rounded-12px p-2">
          <p class="col-4f fsize10 mb-1">October</p>
          <h1 class="text-dark text-2xl mb-1 font-semibold">
            <WeekCalendar
              class="calendar-class"
              v-model="myDate"
              month-format=""
            >
              <template v-slot:days="{ days }">
                <div v-for="day in days" :key="day">
                  {{ new Date(day).getDay() }}
                </div>
              </template>
            </WeekCalendar>
          </h1>
          <p class="col-4f fsize10 mb-0">Tuesday</p>
          <div class="w-full flex justify-center mt-1">
            <div class="bg-ab"></div>
          </div>
        </div>
      </swiper-slide>

      <div class="swiper-button-prev cust-swipsizel" slot="button-prev"></div>
      <div class="swiper-button-next cust-swipsize" slot="button-next"></div>
    </swiper> -->
    <div>
      <div class="bg-white text-center rounded-12px p-2">
        <p class="col-4f fsize10 mb-1">
          <WeekCalendar class="calendar-class" v-model="myDate" month-format="">
            <template v-slot:months="{ months }"
              ><div
                hidden
                class="shadow-lg rounded-xl p-4"
                v-for="(month, index) in months"
                :key="index"
                ref="month"
              >
                {{ new Date(month).getMonth() + 1 }}
              </div></template
            >

            <template v-slot:years="{ years }"
              ><div hidden>{{ years }}</div>
            </template>
            <template v-slot:days="{ days, next, prev, isEqual, change }">
              <div class="grid gap-4 grid-cols-7 relative">
                <div
                  class="absolute h-full items-center flex left0 cursor-pointer"
                >
                  <feather-icon @click="prev" icon="ChevronLeftIcon" />
                </div>

                <div
                  v-for="(day, index) in days"
                  :key="index"
                  class="elshadow rounded-12px p-4 cursor-pointer"
                  :class="{
                    'bg-ffe1': isEqual(new Date(), day),

                    'bg-primary':
                      isEqual(myDate, day) && !isEqual(new Date(), day),
                  }"
                  @click="change(day)"
                >
                  <p
                    class="fsize10 mb-1"
                    :class="[
                      isEqual(myDate, day) || isEqual(new Date(), day)
                        ? 'text-white'
                        : 'col-4f',
                    ]"
                  >
                    {{ month[new Date(day).getMonth()] }}
                  </p>
                  <p
                    class="text-2xl mb-1 font-semibold"
                    :class="[
                      isEqual(myDate, day) || isEqual(new Date(), day)
                        ? 'text-white'
                        : 'text-dark',
                    ]"
                  >
                    {{ new Date(day).getDate() }}
                  </p>

                  <p
                    class="fsize10 mb-0"
                    :class="[
                      isEqual(myDate, day) || isEqual(new Date(), day)
                        ? 'text-white'
                        : 'col-4f',
                    ]"
                  >
                    {{ getDay(day) }}
                  </p>
                  <!-- <div v-for="eventnumber in indice(day)" :key="eventnumber"> -->
                  <div class="flex justify-center items-center">
                    <div
                      class="py-2 flex justify-center gap-2"
                      :class="[
                        isEqual(myDate, day) || isEqual(new Date(), day)
                          ? 'text-white'
                          : 'col-4f',
                      ]"
                    >
                      <div
                        class=""
                        v-for="eventnumber in indice(day)"
                        :key="eventnumber"
                      >
                        <div>
                          <div class="circular-dot"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- </div> -->
                  <!-- {{ day }} -->
                </div>

                <div
                  class="absolute right0 h-full items-center flex cursor-pointer"
                >
                  <feather-icon @click="next" icon="ChevronRightIcon" />
                </div>
              </div>
            </template>
          </WeekCalendar>
        </p>
        <h1 class="text-dark text-2xl mb-1 font-semibold">
          <!-- <WeekCalendar class="calendar-class" v-model="myDate" month-format="">
            <template v-slot:days="{ days }">
              <div v-for="day in days" :key="day">
                {{ new Date(day).getDay() }}
              </div>
            </template>
            <template v-slot:years="{ years }"> </template>
            <template v-slot:months="{ months }"><</template>
          </WeekCalendar> -->
        </h1>
        <!-- <p class="col-4f fsize10 mb-0">Tuesday</p>
        <div class="w-full flex justify-center mt-1">
          <div class="bg-ab"></div>
        </div> -->
      </div>

      <!-- <WeekCalendar class="calendar-class" v-model="myDate" month-format="">
        <template v-slot:years="{ years }">
          {{ new Date(years[0]).getFullYear() }}
        </template>
        <template v-slot:months="{ months }"
        ><div v-for="month in months" :key="month" ref="month">
          {{ new Date(month).getMonth() + 1 }}
        </div></template
      >

        <template v-slot:days="{ days }">
          <div v-for="day in days" :key="day">
            {{ new Date(day).getDay() }}
          </div>
        </template>
      </WeekCalendar> -->
    </div>
  </div>
</template>
<script>
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import WeekCalendar from "vue2-week-calendar";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import FeatherIcon from "../../../../../components/FeatherIcon.vue";
import { mapState } from "vuex";
export default {
  // props: {
  //   indice: {
  //     type: Function,
  //     required: true,
  //   },
  // },
  components: {
    FeatherIcon,
    swiper,
    swiperSlide,
    WeekCalendar,
  },
  data() {
    return {
      myDate: new Date(),
      setDate: new Date(),
      swiperOption: {
        slidesPerView: 9,
        observer: true,
        observeParents: true,
        spaceBetween: 40,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      related_items: [
        {
          name: "Template 1",

          robo: "11",
        },
        {
          name: "Template 2",

          robo: "12",
        },
        {
          name: "Template 3",

          robo: "13",
        },
        {
          name: "Template 4",

          robo: "14",
        },
        {
          name: "Template 5",

          robo: "15",
        },
        {
          name: "Template 6",

          robo: "16",
        },
        {
          name: "Template 7",

          robo: "16",
        },
        {
          name: "Template 8",

          robo: "17",
        },
        {
          name: "Template 9",

          robo: "18",
        },
      ],
      products: [],
      events: [],
      month: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      day: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      Eventindic: {},
    };
  },

  computed: {
    ...mapState("brandProfile", [
      "brandProfile",
      "layoutSelected",
      "googleFontFamily",
    ]),

    checkCurrentDate() {
      return (day) => day.toDateString() == new Date().toDateString();
    },
  },

  watch: {
    myDate(newValue) {
      let date =
        newValue.getDate() < 10
          ? `0${newValue.getDate()}`
          : `${newValue.getDate()}`;
      let month =
        newValue.getMonth() + 1 < 10
          ? `0${newValue.getMonth() + 1}`
          : newValue.getMonth() + 1;
      this.setDate = `${newValue.getFullYear()}-${month}-${date}`;

      this.getEvents();
    },
  },

  methods: {
    indice(day) {
      return this.Eventindic[
        `${this.month[new Date(day).getMonth()]}-${new Date(
          day
        ).getDate()}-${new Date(day).getFullYear()}`
      ];
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    setLayout(index) {
      // console.log(this.layoutSelected, "layout");
      // for (let index = 0; index < this.eventsCard.length; index++) {
      if (index < 9) {
        return this.layoutSelected.layout.includes(index);
      } else {
        const layout = index % 9;
        return this.layoutSelected.layout.includes(layout);
      }
      // }
    },
    async getEvents() {
      const { data } = await this.$store.dispatch("projectFile/getEvents", {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
        // date: this.setDate,
      });

      let events = [];
      let diff = 0;
      let prevdate = "";
      data.data.map((item, index) => {
        // console.log(dateString, this.setDate, "bool");
        // console.log(dateString == this.setDate, "bool");

        if (prevdate == item.eventDate) {
          diff += 1;
          events.push({
            ...item,
            isLayout: this.setLayout(index - diff),
          });
          prevdate = item.eventDate;
          return;
        } else {
          events.push({
            ...item,
            isLayout: this.setLayout(index - diff),
          });
          prevdate = item.eventDate;
          return;
        }
      });
      let events1 = [];
      events.map((item, index) => {
        let date = new Date(item.eventDate);
        const month =
          new Date(date).getMonth() + 1 < 10
            ? `0${new Date(date).getMonth() + 1}`
            : new Date(date).getMonth() + 1;
        const day =
          new Date(date).getDate() < 10
            ? `0${new Date(date).getDate()}`
            : new Date(date).getDate();
        const year = date.getFullYear();
        const dateString = `${year}-${month}-${day}`;
        if (dateString == this.setDate) {
          return events1.push(item);
        }
      });

      this.events = events1;
      this.$emit("setEvents", events1);
    },

    getDay(date) {
      return this.day[new Date(date).getDay()];
    },
    async getAllEvents() {
      const { data } = await this.$store.dispatch("projectFile/getEvents", {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      });
      const events = data.data.map((x, index) => {
        return {
          ...x,
          isLayout: this.setLayout(index),
        };
      });
      let offset = 0;

      events.map((item, index) => {
        let date = new Date(item.eventDate);
        const month = this.month[new Date(date).getMonth()];
        const day = new Date(date).getDate();
        const year = date.getFullYear();
        const dateString = `${month}-${day}-${year}`;
        if (!(dateString in this.Eventindic)) {
          // this.events[index]["isLayout"] = false;

          // this.events[index]["isLayout"] = this.setLayout(index);
          this.Eventindic[dateString] = 0;
        }
        offset += 1;
        // this.events[index]["isLayout"] = this.setLayout(index);
        this.Eventindic[dateString] += 1;
      });
    },
  },
  async mounted() {
    await this.getAllEvents();
    this.myDate = this.setDate;
    await this.getEvents();
    // this.indice(day);
  },
};
</script>
<style scoped>
.calendar-class {
  --week-calendar-accent-color: #599455 !important;
  --week-calendar-accent-text-color: #f5f5f5 !important;
  --week-calendar-border-color: whitesmoke !important;
  --week-calendar-border-active-radius: 8px !important;
  --week-calendar-icon-color: #888 !important;
}
.left0 {
  left: 0;
}
.right0 {
  right: 0;
}
</style>
